import { useQuery } from '@apollo/client';
import { EAccountCreationPermission } from '@/graphql-types/globalTypes';
import { ADD_TO_CART_MODAL_QUERY } from '../graphql/queries';

export interface UseAddToCartModalDataProps {
  eventId: string;
  isOpen: boolean;
}

export const useAddToCartModalData = ({ eventId, isOpen }: UseAddToCartModalDataProps) => {
  const { data, loading, error } = useQuery(ADD_TO_CART_MODAL_QUERY, {
    variables: { input: { _id: eventId } },
    skip: !isOpen,
  });

  const event = data?.event?.eventV2;
  const canSignUp = data?.tenant?.result?.accountCreationPermission === EAccountCreationPermission.ANYONE;

  return {
    event,
    canSignUp,
    loading,
    error,
    data,
  };
};